// extracted by mini-css-extract-plugin
export default {"block":"styles_block__opfe0","title":"styles_title__m+fI1","description":"styles_description__VH8Xb","time":"styles_time__Kd2s5"};